import { createRouter, createWebHistory } from 'vue-router';
import userApi from '../api/user.js';
import couponApi from '../api/coupon.js';
import waitingRoomApi from '../api/waiting-room.js';
import axios from 'axios';
import md5 from 'js-md5';
import { ElLoading, ElMessageBox  } from 'element-plus';
const route = useRoute();
import {useRoute} from 'vue-router';
// ユーザーの存在を確認し、適切なコンポーネントを解決します。
const checkUserExists = async (openId) => {
  let loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Now Loading...'
  });

  try {
    const response = await userApi.checkFannalyMember({ openId });
    let userExists = false;
    let shareCouponReceived = false;

    if (response.code === 200 && response.data != null) {
      if (response.data.sex_type && response.data.birthday) {
        //check share coupon is not received
        let param = {
          openId: openId,
        }
        const shareResponse = await couponApi.checkShareCouponReceived(param);
        if (shareResponse.code === 200 && shareResponse.data != null) {
         
          shareCouponReceived = true;
          sessionStorage.setItem('shareCoupon', JSON.stringify(shareResponse.data));
        }
        sessionStorage.setItem('membershipCardNumber', response.data.membership_card_number);

        let paramPartner = {
          openId: openId,
          membershipCardNumber: response.data.membership_card_number,
          sexType: response.data.sex_type,
          birthday: response.data.birthday,
        };

        await userApi.updateMembershipCardNumber(paramPartner);

        userExists = true;
      } else {
        userExists = false;
      }
    }
    else if (response.code === 400 && response.data != null) {
      if (response.data.errorCode === 'INVALID_CHANNEL_RELATION') {
        userExists = false;
      }
      else {
        userExists = false;

        showWarnMsg(
          '現在、データの取得に失敗しました。数分後に再試行してください。'
        );
      }
    } else if (response.code === 404) {
      userExists = false;
    }

    // 状態を sessionStorage に保存する
    sessionStorage.setItem('userExists', userExists);
    sessionStorage.setItem('shareCouponReceived', shareCouponReceived);
    return userExists;
  } catch (error) {
    return import('@/views/error/error');
  } finally {
    loadingInstance.close();
  }
};

const showWarnMsg = (warnMsg) => {
  ElMessageBox.alert(warnMsg, '', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '閉じる',
    type: 'warning',
    showClose: false,
    center: true,
    iconClass: 'el-message-box-title-icon',
    confirmButtonClass: 'el-message-box-confirm-btn'
  })
    .then(() => {
      closePage();
    })
    .catch(() => {});
};

function closePage() {
  if (typeof liff !== "undefined" && liff.closeWindow) {
    liff.closeWindow();
  } else {
    const ua = navigator.userAgent;
    
    if (ua.indexOf('MSIE') > 0) {
      if (ua.indexOf('MSIE 6.0') > 0) {
        window.opener = null;
        window.close();
      } else {
        window.open('', '_top').close();
      }
    } else if (ua.indexOf('Firefox') > 0) {
      window.location.href = 'about:blank';
    } else {
      window.opener = null;
      window.open('about:blank', '_top').close();
    }
  }
}

const routes = [
    {
      path: '/',
      redirect: '/home',
      meta: {
        authless: true,
        checkStoreId: false
      }, //authentication should not be executed
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/views/error/error'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'エラー画面',
        authless: true,
        checkStoreId: false
      }, //authentication should not be executed
    },
    {
      path: '/searchMap',
      name: 'searchMap',
      component: () => import('@/views/index/searchMap'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: '検索店舗画面',
        checkStoreId: false
      }
    },
    {
      path: '/extbrowser',
      name: 'extbrowser',
      component: () => import('@/views/auth/extbrowser'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: '非LINEブラウザ画面',
        authless: true,
        checkStoreId: false
      },
    },
    {
      path: '/autherror',
      name: 'autherror',
      component: () => import('@/views/auth/autherror'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: '権限付与エラー画面',
        authless: true,
        checkStoreId: false
      },
    },
    // {
    //   path: '/privacypolicy',
    //   name: 'privacypolicy',
    //   component: () => import('@/views/privacypolicy/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: 'プライバシーポリシー画面',
    //     authless: true,
    //     checkStoreId: false
    //   }
    // },
    {
      path: '/privacypolicy',
      name: 'privacypolicy_v2',
      component: () => import('@/views/v2/privacypolicy'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: 'プライバシーポリシー画面',
        authless: true,
        checkStoreId: false
      }
    },
    {
      path: '/get/coupon/:couponCode/:couponId',
      name: 'generateOriginal',
      component: () => import('@/views/generateOriginal/generateOriginal'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'Ticket取得画面',
        checkStoreId: false
      }
    },
    // UZ_OPE-1917 start
    {
      path: '/c/:couponId',
      name: 'generateOriginalCipher',
      component: () => import('@/views/generateOriginal/generateOriginalCipher'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'Ticket取得画面',
        checkStoreId: false
      }
    },
    // UZ_OPE-1917 end
    // {
    //   path: '/storeDetail',
    //   name: 'storeDetail',
    //   component: () => import('@/views/storeDetail/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '特定商取引法に基づく表記画面',
    //     authless: true,
    //     checkStoreId: true
    //   }
    // },
    // {
    //   path: '/orderhistory',
    //   name: 'orderhistory',
    //   component: () => import('@/views/orderhistory/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '注文履歴リスト画面',
    //     checkStoreId: false
    //   }
    // },
    {
      path: '/orderhistory',
      name: 'order_history_v2',
      component: () => import('@/views/v2/orderHistory'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '注文履歴リスト画面',
        checkStoreId: false
      },
      beforeEnter: async (to, from, next) => {
        let openId = sessionStorage.getItem('openId');
          
        if (!openId) {
          await liff.init({ liffId: process.env.VUE_APP_LIFF_ID });
          if (liff.isLoggedIn()) {
            const profile = await liff.getProfile();
            openId = profile.userId;
            sessionStorage.setItem('openId', openId);
          } else {
            return liff.login();
          }
        }

        let userExists = sessionStorage.getItem('userExists');
 
        if (!userExists || userExists === 'false') {
          userExists = await checkUserExists(openId);
          sessionStorage.setItem('userExists', userExists ? 'true' : 'false');
        }
 
        next();
      }
    },
    {
      path: '/orderconfirm',
      name: 'orderconfirm',
      component: () => import('@/views/orderconfirm/index'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: '注文商品詳細画面',
        checkStoreId: false
      }
    },
    // // アクセス
    // {
    //   path: '/map',
    //   name: 'map',
    //   component: () => import('@/views/map/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: 'アクセス画面',
    //     authless: true,
    //     checkStoreId: true
    //   },
    // },
    // お店について
    {
      path: '/aboutshop',
      name: 'aboutshop',
      component: () => import('@/views/aboutshop/index'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'お店について画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/pay',
    //   name: 'pay',
    //   component: () => import('@/views/pay/payconfirm'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '決済画面',
    //     checkStoreId: true
    //   }
    // },
    {
      path: '/pay',
      name: 'pay_v2',
      component: () => import('@/views/v2/pay'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '決済画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/paycomplete',
    //   name: 'paycomplete',
    //   component: () => import('@/views/pay/paycomplete'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '決済完了画面',
    //     authless: true,
    //     checkStoreId: true
    //   }, //authentication should not be executed
    // },
    {
      path: '/paycomplete',
      name: 'pay_complete_v2',
      component: () => import('@/views/v2/payComplete'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '決済完了画面',
        authless: true,
        checkStoreId: true
      },
      beforeEnter: async (to, from, next) => {
        let openId = sessionStorage.getItem('openId');
          
        if (!openId) {
          await liff.init({ liffId: process.env.VUE_APP_LIFF_ID });
          if (liff.isLoggedIn()) {
            const profile = await liff.getProfile();
            openId = profile.userId;
            sessionStorage.setItem('openId', openId);
          } else {
            return liff.login();
          }
        }

        let userExists = sessionStorage.getItem('userExists');
 
        if (!userExists || userExists === 'false') {
          userExists = await checkUserExists(openId);
          sessionStorage.setItem('userExists', userExists ? 'true' : 'false');
        }
 
        next();
      }
    },
    // {
    //   path: '/paycancel',
    //   name: 'paycancel',
    //   component: () => import('@/views/pay/paycancel'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '決済キャセル画面',
    //     authless: true,
    //     checkStoreId: true//authentication should not be executed
    //   },
    // },
    {
      path: '/paycancel',
      name: 'pay_cancel_v2',
      component: () => import('@/views/v2/payCancel'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '決済キャセル画面',
        authless: true,
        checkStoreId: true//authentication should not be executed
      },
    },
    // マイページ
    // お客様情報
    {
      path: '/custominfo',
      name: 'custominfo',
      component: () => import('@/views/custominfo/index'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'お客様情報画面',
        checkStoreId: false
      }
    },
    // お客様情報_編集
    {
      path: '/custominfo/confirm',
      name: 'confirm',
      component: () => import('@/views/custominfo/confirm'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'お客様情報編集画面',
        checkStoreId: false
      }
    },
    {
      path: '/member/member-coupon',
      redirect: '/home',
      // name: 'member-coupon',
      // component: () => import('@/views/member/member-coupon'),
      // meta: {
      //   title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
      //   trackedTitle: 'スタンプ画面',
      //   checkStoreId: false
      // }
    },
    {
      path: '/sound',
      name: 'sound',
      component: () => import('@/views/test/sound'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        authless: true,
        checkStoreId: false
      }
    },
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: () => import('@/views/index/home'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: 'TOP画面',
    //     checkStoreId: false
    //   }
    // },
    {
      path: '/map',
      name: 'map_v2',
      component: () => import('@/views/v2/home'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '商品詳細画面',
        checkStoreId: false
      }
    },
    // {
    //   path: '/storeDetailTwo',
    //   name: 'storeDetailTwo',
    //   component: () => import('@/views/storeDetailTwo/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '特定商取引法に基づく表記2画面',
    //     authless: true,
    //     checkStoreId: false
    //   }
    // },
    {
      path: '/storeDetailTwo',
      name: 'store_detail_two_v2',
      component: () => import('@/views/v2/storeDetailTwo'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '特定商取引法に基づく表記2画面',
        authless: true,
        checkStoreId: false
      }
    },
    {
      path: '/storeDetail',
      name: 'store_detail_v2',
      component: () => import('@/views/v2/storeDetail'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '特定商取引法に基づく表記画面',
        authless: true,
        checkStoreId: true
      }
    },
    // region Eat-In-Feature
    {
      path: '/storeUseType',
      name: 'store_use_type_v2',
      component: async () => {
        const userExists = sessionStorage.getItem('userExists');
        return userExists === 'true'
          ? import('@/views/v2/storeUseType')
          : import('@/views/v2/myPage');
      },
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: 'ご利用方法を選ぶ',
        authless: true,
        checkStoreId: false
      },
      beforeEnter: async (to, from, next) => {
        const openId = sessionStorage.getItem('openId');
        let userExists = sessionStorage.getItem('userExists');
 
        if (!userExists || userExists === 'false') {
          userExists = await checkUserExists(openId);
          sessionStorage.setItem('userExists', userExists ? 'true' : 'false');
        }
 
        next();
      }
    },
    // endregion Eat-In-Feature
    // {
    //   path: '/goodsCategory',
    //   name: 'goodsCategory',
    //   component: () => import('@/views/goodsCategory/goodsCategory'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '商品カテゴリー画面',
    //     checkStoreId: true
    //   }
    // },
    {
      path: '/goodsCategory',
      name: 'goods_category_v2',
      component: () => import('@/views/v2/goodsCategory'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '商品カテゴリー画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/goodsList',
    //   name: 'goodsList',
    //   component: () => import('@/views/goodsList/goodsList'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '商品リスト画面',
    //     checkStoreId: true
    //   }
    // },
    {
      path: '/goodsList',
      name: 'goodsList_v2',
      component: () => import('@/views/v2/goodsList'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '商品リスト画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/goodsDetail',
    //   name: 'goodsDetailInfo',
    //   component: () => import('@/views/goodsDetail/goodsDetail'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '商品詳細画面',
    //     checkStoreId: true
    //   }
    // },
    {
      path: '/goodsDetail',
      name: 'good_detail',
      component: () => import('@/views/v2/goodsDetail'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '商品カテゴリー画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/cart',
    //   name: 'cart',
    //   component: () => import('@/views/cart/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: '注文リスト画面',
    //     checkStoreId: true
    //   }
    // },
    {
      path: '/cart',
      name: 'cart_v2',
      component: () => import('@/views/v2/cart'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '注文リスト画面',
        checkStoreId: true
      }
    },
    // {
    //   path: '/mypage',
    //   name: 'mypage',
    //   component: () => import('@/views/mypage/index'),
    //   meta: {
    //     title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
    //     trackedTitle: 'マイページ画面',
    //     checkStoreId: false
    //   }
    // },
    {
      path: '/mypage',
      name: 'my_page_v2',
      component: () => import('@/views/v2/myPage'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: 'マイページ画面',
        checkStoreId: false
      }
    },
    {
      path: '/home',
      name: 'rank_v2',
      component: async () => {
        const userExists = sessionStorage.getItem('userExists');
        const userId = sessionStorage.getItem('openId');

        let accessToken = null;

        if (!liff.id || !liff.isLoggedIn()) {
          try {
            await liffLogin();
          } catch (error) {
            console.log('LIFF login failed:', error); 
          }
        }

        accessToken = liff.getAccessToken();

        sessionStorage.setItem('shouldConnectSocket', 'false');
        sessionStorage.setItem('waitingRoom', 'false');
        if (userExists === 'true') {
          try {
            const result = await waitingRoomApi.checkSlot({ userId, lineToken: accessToken });

            if (result && result.status === 'error') {
              sessionStorage.setItem('waitingRoom', 'false');
              sessionStorage.setItem('shouldConnectSocket', 'false');
              return import("@/views/v2/rank");
            }
            if (result && result.status === 'allowed') {
              sessionStorage.setItem('waitingRoom', 'false');
              sessionStorage.setItem('shouldConnectSocket', 'true'); 
              return import("@/views/v2/rank");
            }
            if (result && result.status === 'wait') {
              sessionStorage.setItem('waitingRoom', 'true');
              sessionStorage.setItem('shouldConnectSocket', 'false'); 
              window.location.href = '/waiting-room';
              return;
            }
          } catch (error) {
            console.error('checkSlot API error:', error);
            sessionStorage.setItem('waitingRoom', 'false');
            sessionStorage.setItem('shouldConnectSocket', 'false');
            return import("@/views/v2/myPage");
          }
        }
        // (userExists = false)
        return import("@/views/v2/myPage");

      },
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: 'マイページ画面',
        checkStoreId: false
      },
      beforeEnter: async (to, from, next) => {
        const openId = sessionStorage.getItem('openId');
        const userExists = await checkUserExists(openId);
        let homeShareId = to.query.shareId;
        const shareCouponReceived = sessionStorage.getItem('shareCouponReceived');
        const shareCouponData = sessionStorage.getItem('shareCoupon');
        if (shareCouponReceived === 'true' && homeShareId) {
          const shareCoupon = JSON.parse(shareCouponData);
          if (homeShareId === shareCoupon.shareId.toString()) {
            next('/share/recipientcoupon/' + shareCoupon.originalCouponId + '/' + shareCoupon.shareId);
            return;
          }
        }
        document.title = userExists === true ? 'Gong cha／ゴンチャ' : '会員登録';
        next();
      }
    },

    {
      path: '/waiting-room',
      name: 'waiting_room',
      component: () => import('@/views/v2/waitingRoom'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: '待機室画面',
        checkStoreId: false
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/v2/maintenance'),
      meta: {
        title: 'Gong cha／ゴンチャ',
        trackedTitle: 'マイページ画面',
        checkStoreId: false
      }
    },
    {
      path: '/share/originalCoupon/:originalCouponId',
      name: 'introducerCouponDetail',
      component: () => import('@/views/v2/shareCoupon/introducerCouponDetail'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: '紹介者画面',
        checkStoreId: false,
        hideHeader: true
      },
      beforeEnter: async (to, from, next) => {
        let openId = sessionStorage.getItem('openId');
          
        await liff.init({ liffId: process.env.VUE_APP_LIFF_ID });
          
        if (!openId) {
          if (liff.isLoggedIn()) {
            const profile = await liff.getProfile();
            openId = profile.userId;
            sessionStorage.setItem('openId', openId);
          } else {
            return liff.login();
          }
        }
 
        next();
      }
    },
    {
      path: '/share/recipientcoupon/:originalCouponId/:shareId',
      name: 'recipientCouponDetail',
      component: () => import('@/views/v2/shareCoupon/recipientCouponDetail'),
      meta: {
        title: 'Gong cha Japan｜ゴンチャ ジャパン｜貢茶 Japan | 台湾茶 | アジアン ティー カフェ',
        trackedTitle: 'Ticket取得画面',
        checkStoreId: false
      }
    },
  ];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const waitingRoom = sessionStorage.getItem('waitingRoom');
  if (waitingRoom === 'true' && to.path !== '/waiting-room' && to.path !== '/orderhistory' && to.path !== '/privacypolicy' && to.path !== '/storeDetailTwo') {
    return next('/waiting-room');
  }
  next();
});

const originalPush = router.push;
router.push = function push(location) {
  return originalPush(location).catch(err => err);
};

export default router
